import { render, staticRenderFns } from "./SimpleDestinations.vue?vue&type=template&id=212119dd&scoped=true&"
import script from "./SimpleDestinations.vue?vue&type=script&lang=js&"
export * from "./SimpleDestinations.vue?vue&type=script&lang=js&"
import style0 from "./SimpleDestinations.vue?vue&type=style&index=0&id=212119dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212119dd",
  null
  
)

export default component.exports